"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeGRP = function CategoryCodeGRP(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeGRP"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M8.906,8.328h-4a2.534,2.534,0,0,0-2.527,2.527V12.57H8.382a3.234,3.234,0,0,1,.524-4.242Z"
  }), _react.default.createElement("circle", {
    cx: "7.225",
    cy: "5.26",
    r: "2.572"
  }), _react.default.createElement("path", {
    d: "M11.061,8.183a2.565,2.565,0,1,0,2.564,2.564A2.564,2.564,0,0,0,11.061,8.183Zm1.563,2.965h-1.1v1.1H10.6v-1.1H9.5V10.22h1.1v-1.1h.929v1.1h1.1Z"
  }))));
};

var _default = CategoryCodeGRP;
exports.default = _default;